<script>
  export default {
    name: 'v-bottom-sheet',

    props: {
      inset: Boolean,
      value: null
    },

    render (h) {
      const activator = h('template', {
        slot: 'activator'
      }, this.$slots.activator)

      const contentClass = [
        'bottom-sheet',
        this.inset ? 'bottom-sheet--inset' : ''
      ].join(' ')

      return h('v-dialog', {
        attrs: {
          ...this.$attrs
        },
        on: {
          ...this.$listeners
        },
        props: {
          contentClass: contentClass,
          transition: 'slide-y-reverse-transition',
          value: this.value
        }
      }, [activator, this.$slots.default])
    }
  }
</script>

<style>
.bottom-sheet { z-index: 999999; }
.bottom-sheet .dialog { align-self: flex-end; border-radius: 0; flex: 1 0 100%; margin: 0; min-width: 100%; overflow: visible; }
</style>



// WEBPACK FOOTER //
// BottomSheet.vue?2059b377